import React, {useMemo, useEffect, useState} from 'react';
import {isEqual} from 'lodash';

import { isBoolean, isString } from 'lodash';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import Checkbox from '@mui/material/Checkbox';

import FormHelperText from '@mui/material/FormHelperText';

import {useFormStore} from '../../../Stores/form';

import './index.scss';

export default function CheckboxInput(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];
    
    const placeholder = useMemo(() => field.required ? `${field.placeholder} *` : field.placeholder, [field]);

    const [className, setClassName] = useState()

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [value, setValue] = useState(false)
    useEffect(() => {
      let newValue
      if (isString(content[field.id])) {
        newValue = content[field.id] === 'true' || false;
      }
      else if (isBoolean(content[field.id])) {
        newValue = content[field.id];
      }
      else {
        newValue = false;
      }
      if (!isEqual(value, newValue)) setValue(newValue);
    }, [content[field.id]])

    useEffect(() => {
      setClassName(showErrorText ? 'hasError' : '')
    }, [showErrorText])

    return <div className='CheckboxField'>
          <FormGroup className={className}>
            <FormControlLabel
              control={
                <Checkbox
                  disabled={isDisabled}
                  checked={value}
                  // onChange={e => {
                  //   // INFO: it's here, because second paramtere returns value, but onChange expect ID
                  //   onChange(e)
                  // }}
                  onChange={onChange}
                  onBlur={onBlur}
                  // onBlur={e => {
                  //   console.log(content[field.id])
                  //   onBlur({target: {value: content[field.id]}})
                  // }}
                />
              }
              label={placeholder}
            />
          </FormGroup>
          {showErrorText && <FormHelperText className='FormHelperTextError' error={Boolean(showErrorText)}>{showErrorText}</FormHelperText>}
      </div>
}
